import React from "react";
import { motion } from "framer-motion";
import Contact from "../components/Contact";

const ContactPage = () => {
  return (
    <>
      {/* <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.5 }}
        className="pt-16"
      >
        <div className="py-12 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.2 }}
              className="text-center mb-12"
            >
              <h1 className="text-4xl font-bold text-gray-900">Contact Us</h1>
              <p className="mt-4 text-xl text-gray-600">
                Get in touch with our team
              </p>
            </motion.div>
            <Contact />
          </div>
        </div>
      </motion.div> */}
      <Contact />
    </>
  );
};

export default ContactPage;
